import { postJson } from './http';

const API_BASE = `${import.meta.env.BASE_URL}api`;

// Generates a short random ID to de-duplicate rapid re-starts within a session.
function getSessionId() {
  if (typeof sessionStorage !== 'undefined') {
    let id = sessionStorage.getItem('aev_sid');
    if (!id) {
      id = Math.random().toString(36).slice(2);
      sessionStorage.setItem('aev_sid', id);
    }
    return id;
  }
  return null;
}

export async function recordStart() {
  await postJson(`${API_BASE}/assessments/start`, { sessionId: getSessionId() });
  // Fire-and-forget: result is intentionally ignored — never block the UI.
}

export async function submitAssessment({ gateData, answers, scores, overall, route, valueFocus, needRoute }) {
  const payload = {
    firstName: gateData.firstName,
    email: gateData.email,
    company: gateData.company,
    website: gateData.website || null,
    orgType: gateData.orgType,
    answers,
    scorePain: scores.pain,
    scoreFamiliarity: scores.familiarity,
    scoreClarity: scores.clarity,
    scoreReadiness: scores.readiness,
    scoreQ8: scores.q8Score,
    scoreTotal: scores.total,
    overallLevel: overall.level,
    overallPercent: overall.percent,
    route,
    valueFocus: valueFocus || null,
    needRoute: needRoute || null,
    userAgent: navigator.userAgent,
    referrer: document.referrer || null,
  };

  const res = await postJson(`${API_BASE}/assessments`, payload);
  if (!res.ok) {
    console.error('[Collabo XD Assessment] insert failed:', res.status, res.data);
    return { ok: false, error: res.data };
  }
  console.log('[Collabo XD Assessment] Lead captured:', res.data.id);
  return { ok: true, id: res.data.id };
}
